/*
  Open the buyer's mail client with the product already written into the message.

  The subject and body are read from data attributes at click time rather than being baked
  into a mailto href, for one reason: Cloudflare's email obfuscation rewrites any mailto in
  the HTML and undoes it with a script that only runs over the markup present at load.
  Dawn replaces this block on every variant change, so a baked href came back obfuscated
  and dead. Nothing here for the rewriter to find.

  Delegated from the document, because the element itself is replaced on a variant change.
*/
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-atlas-send]');
  if (!button) return;

  const subject = encodeURIComponent(button.dataset.subject || '');
  const body = encodeURIComponent(button.dataset.body || '');
  window.location.href = `mailto:?subject=${subject}&body=${body}`;
});
